import { environment } from '@environments/environment';

const BASE_AUTH_URL = `${environment.oAuthURI}/${environment.oAuthApi}`;

export const AUTH_SERVICE_API_ROUTES = {
	postPassword: `${BASE_AUTH_URL}/password`
};
